import type { CurrentMemberFragment } from 'generated/graphql';
import type { User } from '~/server/types';
import { useAppData } from '@modules-rocco/root/hooks/use-loader-data';

export const isUserLoggedIn = (user: User): user is CurrentMemberFragment => {
    return user.__typename === 'Me';
};

export const useUser = (): User => {
    const data = useAppData();
    return data.user;
};
